module.exports = __webpack_public_path__ + "./Vid_color_0143d680144760d46c0ca9a0adbfb41d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2023/Vid_color.jpg
// module id = 608
// module chunks = 0